{
  "name": "angular.assistonline.eu",
  "version": "1.1.681",
  "scripts": {
    "start": "ng serve",
    "prebuild": "npm --no-git-tag-version version patch",
    "build:assist": "ng build assist --output-hashing all --configuration=production && npm run sentry:sourcemaps",
    "build:mijn": "ng build mijn --output-hashing all  --configuration=production",
    "build:scanner": "ng build scanner --output-hashing all  --configuration=production",
    "build:assist-test": "ng build assist --output-hashing all --configuration=test",
    "build:mijn-test": "ng build mijn --output-hashing all  --configuration=test",
    "build:schematics": "tsc -p projects/schematics/tsconfig.json",
    "push": "npm version patch && git push",
    "push-minor": "npm version minor && git push",
    "push-major": "npm version major && git push",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org assistonline --project javascript-angular ./dist && sentry-cli sourcemaps upload --org assistonline --project javascript-angular ./dist"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.11",
    "@angular/cdk": "^17.3.10",
    "@angular/common": "^17.3.11",
    "@angular/compiler": "^17.3.11",
    "@angular/core": "^17.3.11",
    "@angular/forms": "^17.3.11",
    "@angular/platform-browser": "^17.3.11",
    "@angular/platform-browser-dynamic": "^17.3.11",
    "@angular/router": "^17.3.11",
    "@angular/service-worker": "^17.3.11",
    "@ng-bootstrap/ng-bootstrap": "^16.0.0",
    "@ng-select/ng-select": "^12.0.7    ",
    "@ngneat/hot-toast": "^7.0.0",
    "@ngneat/overview": "^6.0.0",
    "@popperjs/core": "^2.11.8",
    "@sentry/angular": "^10.38.0",
    "@sentry/cli": "^2.58.4",
    "@tinymce/tinymce-angular": "^8.0.1",
    "@types/qrcode": "^1.5.6",
    "@types/tinymce": "^4.6.9",
    "@types/uuid": "^9.0.8",
    "@zxing/browser": "^0.1.5",
    "@zxing/library": "^0.21.0",
    "@zxing/ngx-scanner": "17.0.4",
    "angular-oauth2-oidc": "^15.0.1",
    "bootstrap": "^5.3.2",
    "chart.js": "^4.4.3",
    "class-transformer": "^0.5.1",
    "dayjs": "^1.11.11",
    "iban": "^0.0.14",
    "jspdf": "^2.5.1",
    "jspdf-autotable": "^3.8.2",
    "jwt-decode": "^3.1.2",
    "leaflet": "^1.9.4",
    "mindee": "^3.10.2",
    "ng-dynamic-component": "^10.7.0",
    "ng2-charts": "^6.0.1",
    "ngx-colors": "^3.6.0",
    "ngx-mask": "^17.0.8",
    "primeng": "^17.18.0",
    "qrcode": "^1.5.4",
    "rrule": "^2.8.1",
    "rxjs": "~7.8.1",
    "tinymce": "^7.7.2",
    "tslib": "^2.6.3",
    "uuid": "^9.0.1",
    "xlsx": "^0.18.5",
    "xng-breadcrumb": "^11.0.0",
    "zone.js": "~0.14.7"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.8",
    "@angular-devkit/core": "^17.3.8",
    "@angular-devkit/schematics": "^17.3.8",
    "@angular/cli": "^17.3.10",
    "@angular/compiler-cli": "^17.3.11",
    "@schematics/angular": "^17.3.8",
    "@types/iban": "^0.0.35",
    "@types/jasmine": "~4.6.4",
    "@types/jspdf": "^2.0.0",
    "@types/leaflet": "^1.9.16",
    "@types/node": "~18.19.0",
    "@types/pdfmake": "^0.2.9",
    "@types/tinymce": "^4.6.9",
    "jasmine-core": "~4.6.0",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "3.3.3",
    "tinymce": "^7.7.2",
    "typescript": "~5.4.5",
    "webpack-bundle-analyzer": "^4.10.2"
  }
}
